import {
  FETCH_RESERVATION,
  UPDATE_PRE_ORDER_STATUS,
  UPDATE_RESERVATION,
  UPDATE_CONFIG_SUCCESS,
} from '../actionTypes';

const reservation = (state, action) => {
  switch (action.type) {
    case FETCH_RESERVATION:
    case UPDATE_PRE_ORDER_STATUS:
    case UPDATE_RESERVATION:
      return action.payload;
    case UPDATE_CONFIG_SUCCESS:
      return state.alternateDriveType !== undefined
        ? { ...state, alternateDriveType: '' }
        : state;
    default:
      return state || {};
  }
};

export default reservation;
